import { UrlConstants } from "../url.constants";
export class ApiCommunicationConstants {
    static URL = UrlConstants.API_V2 + "Communication";
    static FUNCTION_GENERATE_EMAIL = "GenerateEmail";
    static FUNCTION_GENERATE_SYSTEM_EMAIL = "GenerateSystemEmail";
    static FUNCTION_GENERATE_SMS = "GenerateSms";
    static FUNCTION_LOG_COMMUNICATION = "LogCommunication";
    static FUNCTION_GENERATE_SECTION_49_NOTICES_EMAIL = "GenerateSection49NoticesEmail";
    static FUNCTION_SEND_NOTICE = "SendNotice";
    static FUNCTION_DOWNLOAD_NOTICE = "DownloadNotice";
}
